"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetLoginPwdRequest = void 0;
var SetLoginPwdRequest = /** @class */ (function () {
    function SetLoginPwdRequest() {
    }
    return SetLoginPwdRequest;
}());
exports.SetLoginPwdRequest = SetLoginPwdRequest;
;
//# sourceMappingURL=setLoginPwd.request.js.map